<template>
	<div class="v-upload">
		<file-pond
			:name="name"
			:label-idle="idle"
			:accepted-file-types="accept"
			:allowFileEncode="true"
			:allow-multiple="allowMultiple"
			:files="rawFiles"
			v-on:updatefiles="updateFiles"
		/>
	</div>
</template>
<script>
import vueFilePond from "vue-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

let FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview,
	FilePondPluginFileEncode
);

export default {
	components: {
		FilePond,
	},

	data() {
		return {
			rawFiles: []
		};
	},

	computed: {
		files: {
			get() {
				if (!this.$attrs.value) {
					this.rawFiles = [];
				}
				return this.allowMultiple ? this.$attrs.value : this.$attrs.value[0];
			},
			set(files) {
				this.value = files;
				this.rawFiles = files;
				let mappedFiles = this.mapFiles(this.value);
				this.$emit("input", this.allowMultiple ? mappedFiles : mappedFiles[0]);
				this.$emit("changed", this.allowMultiple ? this.value : this.value[0]);
			}
		},
		base64files() {
			let files = this.allowMultiple
				? _.map(this.files, function (file) {
					return this.mapFile(file);
				}.bind(this))
				: this.mapFile(this.files[0]);

			return files;
		},
	},

	props: {
		form: {
			required: false,
			type: Object,
		},
		name: {
			required: false,
			type: String,
		},
		accept: {
			required: true,
			type: String,
		},
		allowMultiple: {
			type: Boolean,
			default() {
				return false;
			}
		},
		idle: {
			required: true,
			type: String,
		},
	},

	methods: {
		mapFiles(files) {
			if (!files) {
				return;
			}
			return files.map(file => this.mapFile(file));
		},
		mapFile(file) {
			return {
				file: file.file,
				name: file.filename,
				basename: file.filenameWithoutExtension,
				extension: file.fileExtension,
				size: file.fileSize,
				base64: file.getFileEncodeBase64String(),
			};
		},
		// addFile(error, file) {
		// 	this.files.push(file);
		//
		// 	if (this.form) {
		// 		this.form.set(this.name, this.base64files);
		// 	}
		//
		// 	this.$emit("addFile", this.base64files);
		// },
		// removeFile(error, file) {
		// 	console.log("removeFile", error, file);
		// 	// this.files.push(file);
		// 	//
		// 	// if (this.form) {
		// 	// 	this.form.set(this.name, this.base64files);
		// 	// }
		// 	//
		// 	// this.$emit("addFile", this.base64files);
		// },
		updateFiles(files) {
			this.files = files;
			// this.$set(this, "files", files);
			//
			// if (this.form) {
			// 	this.form.set(this.name, this.files.map(file => this.mapFile(file)));
			// }
			//
			// this.$emit("filesChanged", this.base64files);
		}
	},

	// watch: {
	// 	files(oldValue, newValue) {
	// 		let files = this.allowMultiple
	// 			? _.map(this.files, function (file) {
	// 				return this.mapFile(file);
	// 			}.bind(this))
	// 			: this.mapFile(this.files[0]);
	// 		this.$emit("changed", {
	// 			name: this.name,
	// 			files: files,
	// 		});
	// 	},
	// },
};
</script>
